/** Shown when a legacy ba_ bank must be re-added on the new ACH model. */
export const LEGACY_BANK_EXPIRED_MESSAGE =
    'Your bank connection has expired. Please add your bank again to continue.';

/** Shown when legacy bank was removed but other saved PMs remain on step 4. */
export const LEGACY_BANK_EXPIRED_PICK_OTHER_MESSAGE =
    'Your bank connection has expired and was removed. Please select another payment method, or add your bank again.';

/** Saved ACH not on integration=us_bank_account (legacy ba_ and similar). */
export function isLegacyAchPaymentMethod(item) {
    if (!item || item.type !== 'ACH') {
        return false;
    }
    return item.integration !== 'us_bank_account';
}

/** Count verified ACH + credit cards; skip disabled categories and unverified banks. */
export function countSelectablePaymentMethods(paymentMethods) {
    if (!paymentMethods || !paymentMethods.length) {
        return 0;
    }

    let count = 0;
    for (const category of paymentMethods) {
        if (category.disabled) {
            continue;
        }
        if (category.category_header === 'Credit Cards') {
            count += category.items.length;
        } else if (category.category_header === 'Bank Debits - ACH') {
            count += category.items.filter(
                (item) => item.type === 'ACH' && item.verified !== false,
            ).length;
        }
    }
    return count;
}
